import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const imageUrl = `/product-${product.id}.png`;

  const handleCardClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <div className="product-card" onClick={handleCardClick}>
      <div
        className="product-image"
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      {/* <img
        className="product-image"
        src={imageUrl}
        alt={product.name}
        style={{
          width: "100%",
          height: "150px",
          objectFit: "cover",
        }}
      /> */}
      <div className="product-details">
        <h3>{product.name}</h3>
        <p>Price: ₹{product.price}</p>
        <p>{product.description}</p>
      </div>
    </div>
  );
};

export default ProductCard;
